import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { Box, IconButton, Tab, Table, TableCell, TableHead, TablePagination, TableRow, Tabs, Tooltip } from "@mui/material";
import { Button, Drawer, Stack, TextField } from '@mui/material';
export default function InfinityErrorDetail({ open, row, onClose }: { open: boolean; row: any; onClose: any }) {
    const [openDrawer, SetOpenDrawer] = React.useState<any>(false);
    //const [data, SetData] = React.useState([] as any);
    const [dataError, SetDataError] = React.useState([] as any);

    React.useEffect(() => {
        if (open) {
            // alert(row.ErrorId);    
            let obj: any = new Object();
            obj.QueryType = "ErrorDetail";
            obj.ErrorId = row.ErrorId;
            let jsonString = JSON.stringify(obj);
            let url = "http://csars-cssdata:5111/api/Infinity/" + jsonString;
            // alert(url);



            fetch(url)
                .then(response => (
                    response.json()
                ))
                .then(data =>
                (
                    SetError(data)
                    // SetData(data),
                    // alert(data),
                    // alert(data.length)
                )

                ).catch(
                    error => (alert('Error: ' + error)
                    )
                );

        }
    }, [open]);

    function SetError(data: any) {
        if (data.length > 0) SetDataError(data[0]);

    }


    return (
        <Box display="flex"  >

            <Drawer
                PaperProps={{ style: { width: 'auto', maxWidth: "90%" } }}
                anchor="right"
                open={open}
                onClose={() => onClose(0)}
                variant={'temporary'}
            >
                {/* <DrawerToolbar title={"Error Detail: " + row.ErrorId} onClose={() => onClose(0)} /> */}
                <Box style={{ margin: "5px 10px" }}>
                    <div style={{position:"fixed", right:"25px"}}>
                        <Button size='small' variant="contained" onClick={() => onClose(0)} endIcon={<CloseIcon />}>
                            Close  {dataError.ErrorID}
                        </Button>

                    </div>

                    {/* Error Detail12
                    {dataError.ErrorID} */}
                    <table>
                        <tr>
                            <td>Customer&nbsp;</td>
                            <td>{dataError.CustomerName} ({dataError.SystemID})</td>
                        </tr>
                        <tr>
                            <td>Exeption&nbsp;</td>
                            <td>{dataError.Exception}</td>
                        </tr>
                        <tr>
                            <td>Stacktrace&nbsp;</td>
                            <td>{dataError.StackTrace}</td>
                        </tr>
                        <tr>
                            <td>Created&nbsp;</td>
                            <td>{dataError.SendDate}</td>
                        </tr>
                        <tr>
                            <td>App Path&nbsp;</td>
                            <td>{dataError.AppPath}</td>
                        </tr>
                        <tr>
                            <td>DB+Machine&nbsp;</td>
                            <td>{dataError.ServerName}.{dataError.DatabaseName} ({dataError.Machine}), Domain: {dataError.Domain} </td>
                        </tr>
                        <tr>
                            <td>System&nbsp;</td>
                            <td>{dataError.System}</td>
                        </tr>
                        <tr>
                            <td>Open Forms&nbsp;</td>
                            <td>{dataError.OpenForms}</td>
                        </tr>
                        {/* <tr>
                            <td>Screenshot&nbsp;</td>
                            <td>{dataError.ScreenShot}</td>
                        </tr>   */}
                        <tr>
                            <td colSpan={2}>
                                <img src={"http://infinitylogging.csidealer.com/Screenshots/" + dataError.ScreenShot + ".png"} width="100%"></img>

                            </td>
                        </tr>

                        {/*<tr>
                            <td>App Path&nbsp;</td>
                            <td>{dataError.AppPath}</td>
                        </tr> */}

                    </table>
                </Box>


            </Drawer>


        </Box>

    )
}